export default function initializeDataTables() {
	var allDataTableContainers = $('.list-container--datatables');

	if (allDataTableContainers.length) {
		allDataTableContainers.each(function(index, container) {
			var dataTable = $(container).find('.list-container__table');
			var dataTableContainerId = $(container).attr('id');

			if (dataTableContainerId == undefined){
				dataTableContainerId = $(dataTable[0]).attr('id');
			}
			var pageLength = 10;

			if (dataTable.length && dataTableContainerId != '' && typeof dataTableContainerId != 'undefined') {	
				var defaultOrderingIndex = dataTable.find('.table__th-sort-asc').parents('th').index() > -1 ? dataTable.find('.table__th-sort-asc').parents('th').index() : dataTable.find('.table__th-sort-desc').parents('th').index();
				var defaultOrderingDirection = dataTable.find('.table__th-sort-asc').parents('th').index() > -1 ? 'asc' : 'desc';
				if (defaultOrderingIndex == -1) {
					defaultOrderingIndex = 0;
					defaultOrderingDirection = 'asc';
				}

				if (dataTableContainerId == 'assignment-log'){
					pageLength = -1;
					defaultOrderingIndex = 4;
					defaultOrderingDirection = 'asc';
				}

				var dataTableObject = dataTable.DataTable({
					dom: 'rt<"bottom"lip><"clear">',
					order: [[defaultOrderingIndex, defaultOrderingDirection]],
					pagingType: 'simple_numbers',
					lengthMenu: [
						[10, 20, 50, 100, -1],
						[10, 20, 50, 100, 'All']
					],
					pageLength: pageLength,
					language: {
						oPaginate: {
							sNext: '<i class="bi bi-chevron-right"></i>',
							sPrevious: '<i class="bi bi-chevron-left"></i>',
							sFirst: '<i class="bi bi-chevron-right"></i>',
							sLast: '<i class="bi-solid bi-chevron-right"></i>',
						},
					},
					initComplete: (settings, json) => {
						toggleNoDataClass(settings.oInstance.api(), dataTableContainerId);
						$(`#${dataTableContainerId} .dataTables_paginate`).appendTo(`#${dataTableContainerId} .table__pagination`);
						
						$(`#${dataTableContainerId} .dataTables_info`).appendTo(`#${dataTableContainerId} .table__showing-indicator`);
						datatablesAdjustInfo($(`#${dataTableContainerId} .dataTables_info`));
			
						$(`#${dataTableContainerId} .dataTables_length`).appendTo(`#${dataTableContainerId} .table__show-per-page`);
						$(`#${dataTableContainerId} .table__show-per-page`).find('select').addClass('form-field__select');
						replaceTextOnly($(`#${dataTableContainerId} .table__show-per-page #DataTables_Table_0_length label`), 'entries','Per Page');
					}
				});
			
				dataTableObject.on('draw.dt', function (e, settings, len) {
					datatablesAdjustInfo($(`#${dataTableContainerId} .dataTables_info`));
					toggleNoDataClass(settings.oInstance.api(), dataTableContainerId);
				});

				function toggleNoDataClass(dataTableObject, containerId) {
					const el = document.querySelector(`#${containerId} .list-container__no-data`);
					const pageInfo = dataTableObject.page?.info();
					if (pageInfo && pageInfo.pages == 0) {
						el?.setAttribute('style', 'display: flex !important;');
          			} else {
						el?.setAttribute('style', 'display: none !important;');
          			}
				}
				
				var tableSearchInput = $(`#${dataTableContainerId} .list-container__table-search`);
				if (tableSearchInput.length) {
					tableSearchInput.on('keyup', function() {
						dataTableObject.search(this.value).draw();
					});
				}
			} else if (dataTable.length) {
				console.error('A DataTable is missing the id attribute.', dataTable)
			}
		});
		
		function datatablesAdjustInfo(infoElement) {
			replaceTextOnly(infoElement, 'Showing ', '');
			replaceTextOnly(infoElement, ' to ', '-');
			replaceTextOnly(infoElement, ' entries', '');
		}

		function replaceTextOnly(element, textToReplace, textReplaceWith) {
			element.contents().filter(function() {
				return this.nodeType == 3
			}).each(function(){
				this.textContent = this.textContent.replace(textToReplace, textReplaceWith);
			});
		}
	}
}
